module.exports = __webpack_public_path__ + "img/slide-3.e98781e2.png";